import { round } from './numberUtils'

export const addNecessaryLeadingZeros = (number: string | number, expectedSize = 2): string => {
  return String(number).padStart(expectedSize, '0')
}

export const addCommas = (number: string | number) => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}

export const priceFormat = (
  price: string | number | undefined | null,
  minimumFractionDigits = 2
) => {
  const value = Number(typeof price === 'string' ? price.replace(',', '.') : price)
  return !value && isNaN(value)
    ? undefined
    : round(value, 2).toLocaleString('es', { minimumFractionDigits, useGrouping: true })
}
